import { StatusAlert } from '@wix/wix-ui-icons-common';
import { Spinner, Tooltip } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React from 'react';
import styles from './email-validation-suffix-wut.module.scss';
import { EmailDeliverabilityStatus } from './email-validation-types';
export const EMAIL_VALIDATION_SUFFIX_DATA_HOOK = 'email-validation-suffix';
export const EmailValidationSuffixWUT = ({ status, message })=>{
    if (status === EmailDeliverabilityStatus.CHECKING) {
        return /*#__PURE__*/ React.createElement("span", {
            "data-hook": EMAIL_VALIDATION_SUFFIX_DATA_HOOK,
            className: styles.suffix,
            "aria-live": "polite"
        }, /*#__PURE__*/ React.createElement(Spinner, {
            diameter: 18,
            isCentered: false
        }));
    }
    if (status === EmailDeliverabilityStatus.INVALID) {
        return /*#__PURE__*/ React.createElement(Tooltip, {
            content: message,
            placement: "top"
        }, /*#__PURE__*/ React.createElement("span", {
            "data-hook": EMAIL_VALIDATION_SUFFIX_DATA_HOOK,
            className: classNames(styles.suffix, styles.invalid),
            "aria-live": "polite"
        }, /*#__PURE__*/ React.createElement(StatusAlert, {
            "aria-label": message
        })));
    }
    return null;
};

//# sourceMappingURL=email-validation-suffix-wut.js.map